var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var label = {
    MuiFormLabel: {
        styleOverrides: {
            root: function (_a) {
                var ownerState = _a.ownerState;
                return (__assign(__assign({}, (ownerState.color === 'info' && {
                    color: 'var(--mui-palette-input-label)'
                })), { '&.Mui-focused': {
                        color: 'var(--mui-palette-primary-main)'
                    } }));
            }
        }
    }
};
export default label;
